import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/Popover/popover.mjs';
import { css } from '@patternfly/react-styles';
export const PopoverBody = (_a) => {
    var { children, id, className } = _a, props = __rest(_a, ["children", "id", "className"]);
    return (_jsx("div", Object.assign({ className: css(styles.popoverBody, className), id: id }, props, { children: children })));
};
PopoverBody.displayName = 'PopoverBody';
//# sourceMappingURL=PopoverBody.js.map